import type { Component } from 'svelte';

export const prerender = true;

export const load = async ({ params, url }) => {
	const { slug } = params;

	const post = await import(`./../../../posts/${decodeURIComponent(slug)}/post.md`);
	console.log('Running post load function:', slug);
	const { headings, ...rest } = post.metadata;
	const ogImage = `${url.pathname}.png`;
	return {
		Post: post.default as Component,
		seoMetadata: {
			title: rest.title,
			description: rest.description,
			image: ogImage
		},
		metadata: rest as BlogPostMetadata,
		headings
	};
};
